import { NavLink, Outlet } from 'react-router-dom';

/**
 * The agency administration shell.
 *
 * Administration lives on the web rather than in the native app (checklist I5): it is desk
 * work, it is the most form-heavy part of the product and phones are the worst place to fill
 * in forms, it changes most often and on the web that costs a deploy rather than a store
 * review, and a desktop table can express a filter-and-sort surface a phone screen cannot.
 */
export function AdminLayout() {
  return (
    <div className="admin">
      {/* A skip link is the cheapest possible accessibility win and the most often missing:
          without it a keyboard user tabs through the whole nav on every single page. */}
      <a className="skip" href="#admin-main">Skip to content</a>
      <nav className="admin-nav" aria-label="Administration">
        <NavLink to="/admin/team" className={navClass}>Team</NavLink>
        <NavLink to="/admin/clients" className={navClass}>Clients</NavLink>
        <NavLink to="/admin/portal-users" className={navClass}>Portal users</NavLink>
        <NavLink to="/admin/connections" className={navClass}>Connections</NavLink>
        <NavLink to="/admin/settings" className={navClass}>Settings</NavLink>
      </nav>
      <div id="admin-main" className="page">
        <Outlet />
      </div>
    </div>
  );
}

const navClass = ({ isActive }: { isActive: boolean }) =>
  isActive ? 'admin-navlink admin-navlink-active' : 'admin-navlink';
